import { useCallback } from 'react';
import type { ApolloClient } from '@apollo/client';
import { useApolloClient, useMutation } from '@apollo/client/react';
import { useAppContext } from 'contexts/AppContext';
import RefreshTokenService from 'services/RefreshTokenService';
import { LogoutDocument, MeDocument, type MeQuery } from 'graphql/generated/graphql';

export const afterLogout = (client: ApolloClient) => {
  RefreshTokenService.clearRefreshToken();
  client.writeQuery<MeQuery>({ query: MeDocument, data: { me: null } });
  // The refetches of the queries still watched while React leaves /secure end with UNAUTHENTICATED or are
  // aborted (Apollo Client 4 aborts a request when its last watcher unmounts); the session is over either way.
  client.resetStore().catch(() => {});
};

const useLogout = () => {
  const client = useApolloClient();
  const [logoutMutation] = useMutation(LogoutDocument);
  const { toggleSidebar } = useAppContext();

  const logout = useCallback(async () => {
    if (RefreshTokenService.getRefreshToken()) {
      await logoutMutation();
    }
    afterLogout(client);
    toggleSidebar(false);
  }, [client, logoutMutation, toggleSidebar]);

  return logout;
};

export default useLogout;
